module.exports = __webpack_public_path__ + "img/header/cha-watermark.svg";